import IconWaffle from '@bimser/icons/16/waffle';
import { Children, FC, PropsWithChildren, isValidElement } from 'react';
import BCButton from '../BCButton';
import Styles from './assets/style.scss';
import { BCHeaderProps } from './entities';

const BCHeaderPanel: FC<PropsWithChildren<BCHeaderProps>> & {
	LeftSection: FC<PropsWithChildren<{}>>;
	RightSection: FC<PropsWithChildren<{}>>;
} = ({ children, onDrawerToggle }) => {
	const leftSection = Children.toArray(children).find(
		child => isValidElement(child) && child.type === BCHeaderPanel.LeftSection
	);
	const rightSection = Children.toArray(children).find(
		child => isValidElement(child) && child.type === BCHeaderPanel.RightSection
	);

	return (
		<div className={Styles.menubarContainer}>
			<div className={Styles.menuTrigger}>
				<BCButton
					cssClass="drawerToggleButton"
					type="link"
					size="large"
					icon={<IconWaffle />}
					onClick={onDrawerToggle}
				/>
				<span>BimserSynergy</span>
			</div>
			<div className={Styles.leftSection}>{leftSection}</div>
			{rightSection}
		</div>
	);
};

const LeftSection: FC<PropsWithChildren<{}>> = ({ children }) => {
	return <>{children}</>;
};

const RightSection: FC<PropsWithChildren<{}>> = ({ children }) => {
	return <>{children}</>;
};

BCHeaderPanel.LeftSection = LeftSection;
BCHeaderPanel.RightSection = RightSection;

export { BCHeaderProps };
export default BCHeaderPanel;
